import { FC, useEffect, useMemo, useState } from "react";
import { BillingsOrderForwardRelatedTaxiTaxiItem } from "../../../../../../common/services/billings/order-forward/related/taxi-taxi/billings-order-forward-related-taxi-taxi";
import { useAppContext } from "../../../../../../context/app.context";
import useBillingsOrderForwardRelatedTaxiTaxi from "../../../../../../common/services/billings/order-forward/related/taxi-taxi/use-billings-order-forward-related-taxi-taxi";
import useAbort from "../../../../../../common/hooks/use-abort";
import billingsTranslationsHelper from "../../../../../../languages/billings-translations.helper";
import CardComponent from "../../../../../../common/components/card/card.component";
import RelatedBillingsTaxiTaxiTableRow from "../../../../common/related-billings/taxi-taxi/types/related-billings-taxi-taxi-table-row";
import RelatedBillingsTaxiTaxiTableComponent from "../../../../common/related-billings/taxi-taxi/related-billings-taxi-taxi-table.component";
import relatedBillingsTaxiTaxiFactory from "./related-billings-taxi-taxi.factory";

type RelatedBillingsTaxiTaxiProps = {
  forwardingId: string;
};

const RelatedBillingsTaxiTaxiComponent: FC<RelatedBillingsTaxiTaxiProps> = (
  props,
) => {
  const translations =
    billingsTranslationsHelper.getBillingsTranslations().relatedBillings
      .taxi_taxi;

  const [relatedBillingsTaxiTaxiData, setRelatedBillingsTaxiTaxiData] =
    useState<BillingsOrderForwardRelatedTaxiTaxiItem[]>([]);

  const { selectedAppLanguage } = useAppContext();
  const taxiTaxi = useBillingsOrderForwardRelatedTaxiTaxi();
  const taxiTaxiAbort = useAbort();

  const taxiTaxiData = async () => {
    taxiTaxi.load({ forwardingUuid: props.forwardingId }, taxiTaxiAbort.signal);
  };

  useEffect(() => {
    if (!props.forwardingId) return;

    taxiTaxiData();
  }, [props.forwardingId]);

  useEffect(() => {
    if (!taxiTaxi.data.data) return;

    setRelatedBillingsTaxiTaxiData(taxiTaxi.data.data);
  }, [taxiTaxi.data.data]);

  const tableRows: RelatedBillingsTaxiTaxiTableRow[] = useMemo(() => {
    if (!relatedBillingsTaxiTaxiData) return [];

    return relatedBillingsTaxiTaxiFactory.createTableRows(
      relatedBillingsTaxiTaxiData,
    );
  }, [relatedBillingsTaxiTaxiData, selectedAppLanguage]);

  return (
    <CardComponent
      classNames={{ root: "related_billings" }}
      header={{ title: translations.summaryLabel }}
    >
      <RelatedBillingsTaxiTaxiTableComponent
        tableRows={tableRows}
        isLoading={taxiTaxi.isLoading && !!props.forwardingId}
      />
    </CardComponent>
  );
};

export default RelatedBillingsTaxiTaxiComponent;
